//Form files
$(document).ready(function () {
  if ($(".contact-wrapper .uploader-input-file").is(":visible")) {
    var txt = $(".contact-wrapper .form-file").data("addfile");

    $(".contact-wrapper .form-file .uploader-upload").append(
      '<span class="form-file-name">' + txt + "</span>"
    );
  }

  // ON CHANGE
  $(".uploader-input-file").on("change", function () {
    var element = $(this);
    var value = $(this).val().replace("C:\\fakepath\\", "");
    var fNSelector = $(this).parents(".uploader-main").find(".form-file-name");

    $(fNSelector).each(function () {
      $(this).remove();
    });

    if (value != "") {
      $(element)
        .closest(".uploader-upload")
        .append('<span class="form-file-name">' + value + "</span>");
    } else {
      $(element)
        .closest(".uploader-upload")
        .append('<span class="form-file-name">' + txt + "</span>");
    }
  });
});

//Mob menu
$(document).ready(function () {
  $("#nav-toggle-button").click(function () {
    $(this).addClass("active");
    $(this).parents(".mob-header").siblings(".main-nav").toggleClass("active");
    $("html, body").addClass("overflow-hidden");
  });

  $(".main-nav .close").click(function () {
    $("#nav-toggle-button").removeClass("active");
    $(".main-nav").removeClass("active");
    $("html, body").removeClass("overflow-hidden");
  });
});

//Info tabs changing
$(document).ready(function () {
  var mobile;
  if (window.innerWidth < 980) {
    mobile = true;
    mobileResize();
  } else {
    mobile = false;
    desktopResize();
  }

  $(window).resize(function () {
    if (window.innerWidth < 980) {
      if (!mobile) {
        mobileResize();
        mobile = true;
      }
    } else {
      if (mobile) {
        desktopResize();
        mobile = false;
      }
    }
  });

  function mobileResize() {
    $(".info-menu-btn").removeClass("active");
    $("#tab1").hide();
    $("#tab2").hide();
    $("#tab3").hide();
    $("#tab4").hide();
    $("#tab1").insertAfter("#btn-tab1");
    $("#tab2").insertAfter("#btn-tab2");
    $("#tab3").insertAfter("#btn-tab3");
    $("#tab4").insertAfter("#btn-tab4");
  }

  function desktopResize() {
    if ($(".pr-wrapper").length == 0 && $(".media-wrapper").length == 0) {
      $(".info-menu-btn").removeClass("active");
      $("#btn-tab1").addClass("active");
    }

    $("#tab1").show();
    $("#tab2").hide();
    $("#tab3").hide();
    $("#tab4").hide();
    $("#tab1").insertAfter(".info-menu-stripe");
    $("#tab2").insertAfter("#tab1");
    $("#tab3").insertAfter("#tab2");
    $("#tab4").insertAfter("#tab3");
  }

  $("#btn-tab1").click(function () {
    if (mobile) {
      $("#tab1").toggle(200);
      $(this).toggleClass("active");
    } else {
      $("#tab1").show();
      $(this).addClass("active");
    }
    $("#tab2").hide();
    $("#tab3").hide();
    $("#tab4").hide();
    $("#btn-tab2").removeClass("active");
    $("#btn-tab3").removeClass("active");
    $("#btn-tab4").removeClass("active");
  });
  $("#btn-tab2").click(function () {
    if (mobile) {
      $("#tab2").toggle(200);
      $(this).toggleClass("active");
    } else {
      $("#tab2").show();
      $(this).addClass("active");
    }
    $("#tab1").hide();
    $("#tab3").hide();
    $("#tab4").hide();
    $("#btn-tab1").removeClass("active");
    $("#btn-tab3").removeClass("active");
    $("#btn-tab4").removeClass("active");
  });
  $("#btn-tab3").click(function () {
    if (mobile) {
      $("#tab3").toggle(200);
      $(this).toggleClass("active");
    } else {
      $("#tab3").show();
      $(this).addClass("active");
    }
    $("#tab1").hide();
    $("#tab2").hide();
    $("#tab4").hide();
    $("#btn-tab1").removeClass("active");
    $("#btn-tab2").removeClass("active");
    $("#btn-tab4").removeClass("active");
  });
  $("#btn-tab4").click(function () {
    if (mobile) {
      $("#tab4").toggle(200);
      $(this).toggleClass("active");
    } else {
      $("#tab4").show();
      $(this).addClass("active");
    }
    $("#tab1").hide();
    $("#tab2").hide();
    $("#tab3").hide();
    $("#btn-tab1").removeClass("active");
    $("#btn-tab2").removeClass("active");
    $("#btn-tab3").removeClass("active");
  });
});

//FAQ show active
$(document).ready(function () {
  $(".FAQ-item h5").click(function () {
    $(this).next().toggle(500);
    $(this).children("span").toggleClass("active");
  });
});

//Scroll down on homepage sales
$(document).ready(function () {
  $(".sales-arrow").click(function () {
    var pos = $(".sales-wrapper").offset().top;
    $("html, body").animate({ scrollTop: pos }, "500");
  });
});

//Header show/hide on scroll
$(document).ready(function () {
  var mobile;
  var didScroll;
  var lastScrollTop = 0;
  var delta = 5;
  var navbarHeight = $("header").outerHeight();
  var requestFrame =
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    window.oRequestAnimationFrame;

  $(window).scroll(function (event) {
    didScroll = true;
  });

  function as() {
    if (!didScroll) {
      requestFrame(as);
      return false;
    } else {
      hasScrolled();
      didScroll = false;
    }
    requestFrame(as);
  }
  as();

  if (window.innerWidth < 980) {
    mobile = true;
  } else {
    mobile = false;
  }

  $(window).resize(function () {
    if (window.innerWidth < 980) {
      if (!mobile) {
        mobile = true;
      }
    } else {
      if (mobile) {
        mobile = false;
        as();
      }
    }
  });

  function hasScrolled() {
    var st = $(this).scrollTop();

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) return;

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight) {
      // Scroll Down
      $("header").removeClass("nav-down").addClass("nav-up");
    } else {
      // Scroll Up
      if (st + $(window).height() < $(document).height()) {
        $("header").removeClass("nav-up").addClass("nav-down");
      }
    }

    lastScrollTop = st;
  }
});

//open PR tab from another page
$(document).ready(function () {
  if ($(".info-menu").is(":visible")) {
    if (document.location.search.length) {
      var tab = window.location.search.substr(1).split("=")[1];
      tab = ".section" + tab;
      if (tab.length) {
        $(tab).click();
      }
    }
  }
});

//back from PR detail to PR list
$(document).ready(function () {
  $("#prBack").click(function (e) {
    e.preventDefault();
    var section = $(this).data("section");
    var href = $(this).attr("href");
    window.location.href = href + "?sekce=" + section;
  });
});

//toggle more contacts
$(document).ready(function () {
  $("#moreContacts").click(function () {
    $(this).children(".contact-arrow-icon").toggleClass("active");
    $(".branches-wrapper").toggle("slow");
  });
});
